"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegeneratePluginArguments = exports.RegeneratePluginOptions = void 0;
exports.RegeneratePluginOptions = [
    {
        name: "select-plugin-manifest",
        type: "string",
        description: "Select plugin manifest file.",
        required: true,
    },
    {
        name: "select-openapi-spec-from-plugin",
        type: "string",
        description: "Select OpenAPI description document file.",
        required: true,
    },
    {
        name: "api-operation",
        type: "array",
        shortName: "o",
        description: "Select operation(s) Copilot can interact with.",
        required: true,
    },
];
exports.RegeneratePluginArguments = [];
//# sourceMappingURL=RegeneratePluginOptions.js.map